import { AbstractSearchDataMessage } from "./abstractSearchDataMessage"

export class DeleteSearchMessage extends AbstractSearchDataMessage {
}
